module.exports = __webpack_public_path__ + "static/media/HP.2724dd8c.png";